export const termsHtml = (logo) => {
    return (`
    
<!DOCTYPE html>
<html lang="it">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Votiamo - Termini e Condizioni</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            margin: 0;
            padding: 0 20px;
            background-color: #f9f9f9;
        }
        header {
            text-align: center;
            background-color: #fff;
            color: #124559;
            padding: 20px 0;
        }
        h1 {
            margin: 0;
        }
        section {
            margin: 20px 0;
            padding: 20px;
            background: white;
            border: 1px solid #ddd;
            border-radius: 5px;
        }
        h2 {
            color: #124559;
            margin-top: 0;
        }
        ul {
            padding-left: 20px;
        }
        li {
            margin-bottom: 10px;
        }
        footer {
            text-align: center;
            margin: 20px 0;
            color: #777;
        }
        a {
            color: #124559;
        }
    </style>
</head>
<body>
<header>
    <img src="${logo}" alt="Logo Votiamo" style="max-width: 150px; margin: 20px auto; display: block;">
    <h1>Termini e Condizioni</h1>
</header>

<section>
    <h2>Benvenuto/a</h2>
    <p>Benvenuto/a su Votiamo. L'utilizzo dell'app implica l'accettazione dei seguenti Termini e Condizioni. Si prega di leggere attentamente quanto segue prima di utilizzare l'app. In caso di domande, contatta il nostro team di supporto.</p>
</section>

<section>
    <h2>1. Scopo dell'App</h2>
    <p>Votiamo è un'applicazione progettata per creare e partecipare a sondaggi in modo interattivo. L'app fornisce strumenti per raccogliere e analizzare opinioni, garantendo al contempo la privacy degli utenti.</p>
</section>

<section>
    <h2>2. Registrazione e Dati dell'Utente</h2>
    <p>Per registrarsi e utilizzare Votiamo, gli utenti devono fornire alcune informazioni di base, tra cui:</p>
    <ul>
        <li>Data di nascita</li>
        <li>Genere</li>
        <li>Città di residenza</li>
        <li>Stato di famiglia</li>
        <li>Titolo di studio</li>
    </ul>
    <p>Questi dati vengono utilizzati esclusivamente a fini statistici e di analisi dei sondaggi. Non è richiesto alcun documento di verifica per tali informazioni, e i contatti personali (come email e numero di telefono) non saranno mai resi visibili né comunicati ai creatori dei sondaggi o ad altri utenti.</p>
</section>

<section>
    <h2>3. Privacy e Sicurezza</h2>
    <p>Votiamo si impegna a proteggere la privacy degli utenti. Gli utenti possono decidere se rendere visibili le informazioni del proprio profilo ad altri utenti o nasconderle. È anche possibile partecipare in modo anonimo, se il creatore del sondaggio abilita questa opzione. Le risposte fornite nei sondaggi anonimi non saranno associate al profilo dell'utente né visibili al creatore del sondaggio. Le informazioni di contatto non saranno mai divulgate ad altri utenti.</p>
</section>

<section>
    <h2>4. Funzionalità dell'App</h2>
    <p>Votiamo offre le seguenti funzionalità principali:</p>
    <ul>
        <li>Creazione di Sondaggi: I creatori possono impostare sondaggi pubblici o privati e limitare la partecipazione in base a determinate caratteristiche (es. età, città).</li>
        <li>Partecipazione ai Sondaggi: Gli utenti possono partecipare ai sondaggi in modalità privata o anonima.</li>
        <li>Statistiche Avanzate: I risultati dei sondaggi possono essere analizzati attraverso filtri specifici per ottenere analisi dettagliate.</li>
    </ul>
</section>

<section>
    <h2>5. Responsabilità dell'Utente</h2>
    <p>Gli utenti di Votiamo sono tenuti a utilizzare l'app in conformità con tutte le leggi e i regolamenti applicabili, nonché con i presenti Termini e Condizioni. Di seguito sono dettagliate le responsabilità specifiche:</p>
    <ul>
        <li>Accuratezza dei Dati: L'utente è responsabile della veridicità e dell'accuratezza delle informazioni fornite durante la registrazione e l'utilizzo dell'app. L'app non si assume alcuna responsabilità per errori o omissioni nei dati inseriti dall'utente.</li>
        <li>Comportamento Adeguato: Gli utenti devono utilizzare l'app in modo rispettoso e appropriato. È vietato utilizzare l'app per scopi fraudolenti, illegali o non autorizzati. Questo include l'astensione da attività che possano danneggiare, disabilitare o sovraccaricare i nostri servizi.</li>
        <li>Contenuti dei Sondaggi: I creatori di sondaggi sono interamente responsabili dei contenuti che pubblicano. Devono assicurarsi che i loro sondaggi non contengano:
            <ul>
                <li>Contenuti Illegali o Illeciti: Materiale che viola leggi o regolamenti applicabili.</li>
                <li>Contenuti Pornografici o Osceni: Materiale sessualmente esplicito o che offende il comune senso del pudore.</li>
                <li>Incitamento all'Odio o alla Violenza: Contenuti che promuovono discriminazione, odio, razzismo, xenofobia, estremismo o violenza contro individui o gruppi.</li>
                <li>Violazione di Diritti di Terzi: Inclusi, ma non limitati a, diritti d'autore, marchi registrati, segreti commerciali o altri diritti di proprietà intellettuale.</li>
                <li>Contenuti Fraudolenti: Promesse di premi falsi o che non verranno assegnati.</li>
            </ul>
        </li>
        <li>Segnalazione di Abusi: Gli utenti sono incoraggiati a segnalare qualsiasi contenuto o comportamento che ritengono violi i presenti Termini e Condizioni contattando il nostro team all'indirizzo support@votiamo.com.</li>
        <li>Conseguenze delle Violazioni: La violazione dei presenti Termini può comportare:
            <ul>
                <li>Sospensione o Eliminazione dell'Account: L'app può sospendere temporaneamente o eliminare definitivamente l'account dell'utente senza preavviso.</li>
                <li>Segnalazione alle Autorità: In caso di attività illegali, l'app si riserva il diritto di segnalare l'utente alle autorità competenti.</li>
                <li>Azione Legale: L'app può intraprendere azioni legali per proteggere i propri diritti e quelli degli altri utenti.</li>
            </ul>
        </li>
    </ul>
</section>

<section>
    <h2>6. Limitazioni di Utilizzo</h2>
    <p>Per mantenere un ambiente sicuro e rispettoso, sono stabilite le seguenti limitazioni:</p>
    <ul>
        <li>Contenuti Proibiti per i Creatori di Sondaggi:
            <ul>
                <li>Contenuti Illeciti o Illegali: È severamente vietato creare sondaggi che includano materiale illegale, come diffamazione, calunnia, frode, violazione della privacy o qualsiasi altro contenuto che violi leggi o regolamenti.</li>
                <li>Contenuti Pornografici o Osceni: Non è permesso pubblicare sondaggi con contenuti pornografici, osceni o che offendano il comune senso del pudore.</li>
                <li>Incitamento all'Odio o alla Violenza: È proibito qualsiasi contenuto che inciti all'odio, alla violenza o alla discriminazione basata su razza, etnia, nazionalità, religione, genere, orientamento sessuale o disabilità.</li>
                <li>Violazione di Diritti di Proprietà Intellettuale: Non è consentito utilizzare materiali protetti da diritti d'autore, marchi registrati o altri diritti di proprietà intellettuale senza l'autorizzazione del titolare.</li>
                <li>Contenuti Fraudolenti o Ingannevoli: È vietato promettere premi falsi o non assegnare i premi promessi nei sondaggi. Tali azioni sono considerate fraudolente.</li>
            </ul>
        </li>
        <li>Conseguenze per i Creatori di Sondaggi:
            <ul>
                <li>Ban Permanente: I creatori che violano queste politiche saranno soggetti a un ban permanente dall'app.</li>
                <li>Segnalazione alle Autorità: In caso di violazioni gravi, come la pubblicazione di contenuti illegali, l'app segnalerà tali attività alle autorità competenti.</li>
                <li>Cancellazione dell'Account: L'app si riserva il diritto di cancellare gli account dei creatori di sondaggi a proprio insindacabile giudizio, specialmente in caso di violazioni ripetute o gravi dei Termini e Condizioni.</li>
            </ul>
        </li>
        <li>Limitazioni per gli Utenti Partecipanti:
            <ul>
                <li>Responsabilità dei Contenuti: L'app non si assume la responsabilità per i contenuti dei sondaggi; questa ricade interamente sui creatori dei sondaggi stessi.</li>
                <li>Segnalazione di Contenuti Inappropriati: Gli utenti che individuano sondaggi con contenuti che violano queste politiche sono invitati a segnalarli immediatamente a support@votiamo.com.</li>
                <li>Comportamento Appropriato: Gli utenti devono astenersi da qualsiasi forma di abuso, molestia o comportamento inappropriato nei confronti di altri utenti o creatori di sondaggi.</li>
            </ul>
        </li>
        <li>Diritti dell'App:
            <ul>
                <li>Rimozione di Contenuti: L'app si riserva il diritto di rimuovere qualsiasi contenuto che ritenga, a suo insindacabile giudizio, in violazione dei presenti Termini e Condizioni o delle leggi applicabili.</li>
                <li>Sospensione degli Account: L'app può sospendere o eliminare gli account degli utenti che violano queste limitazioni, senza preavviso e a propria discrezione.</li>
                <li>Assenza di Responsabilità: L'app non è responsabile per eventuali perdite o danni derivanti dalla sospensione o dall'eliminazione di account a seguito di violazioni dei Termini e Condizioni.</li>
            </ul>
        </li>
        <li>Uso Legittimo della Piattaforma:
            <ul>
                <li>Proibizione di Attività Illegali: È vietato utilizzare l'app per scopi illegali o non autorizzati, inclusa la promozione di attività criminali.</li>
                <li>Divieto di Manipolazione: Gli utenti non devono tentare di aggirare, disabilitare o interferire con le funzionalità di sicurezza dell'app o con le funzionalità che impediscono o limitano l'uso o la copia di qualsiasi contenuto.</li>
                <li>Divieto di Accesso Non Autorizzato: Non è permesso accedere o tentare di accedere ad account di altri utenti o a sistemi o reti collegati all'app senza autorizzazione.</li>
            </ul>
        </li>
    </ul>
    <p>Ricordiamo che il rispetto di queste limitazioni è essenziale per garantire un'esperienza positiva e sicura per tutti gli utenti di Votiamo. La violazione di queste regole può avere conseguenze gravi, inclusa l'azione legale.</p>
</section>

<section>
    <h2>7. Proprietà Intellettuale</h2>
    <p>Tutti i contenuti, i marchi, il logo e le funzionalità dell'app sono di proprietà di Votiamo o dei suoi licenziatari. Gli utenti non possono copiare, modificare, o distribuire i contenuti dell'app senza previa autorizzazione scritta.</p>
</section>

<section>
    <h2>8. Limitazione di Responsabilità</h2>
    <p>Votiamo non è responsabile per eventuali danni, diretti o indiretti, derivanti dall'uso dell'app. L'app fornisce una piattaforma per la creazione di sondaggi, ma non è responsabile dell'accuratezza dei risultati dei sondaggi o delle decisioni prese dagli utenti sulla base di tali risultati.</p>
</section>

<section>
    <h2>9. Modifiche ai Termini</h2>
    <p>Votiamo si riserva il diritto di modificare questi Termini e Condizioni in qualsiasi momento. Gli utenti saranno informati di eventuali modifiche, che entreranno in vigore al momento della pubblicazione.</p>
</section>

<section>
    <h2>10. Recesso e Cancellazione dell'Account</h2>
    <p>Gli utenti possono cancellare il proprio account in qualsiasi momento. La cancellazione comporta la rimozione di tutti i dati personali associati all'account.</p>
    <p>Per evitare frodi relative a partecipazioni multiple ai sondaggi, è richiesto un periodo di minimo 3 mesi e massimo 6 mesi prima che un utente possa registrarsi nuovamente all'app utilizzando gli stessi contatti (email e numero di telefono). Durante questo periodo, l'utente non potrà creare un nuovo account con le stesse informazioni di contatto utilizzate precedentemente.</p>
    <p>Dettagli Aggiuntivi:</p>
    <ul>
        <li>Periodo di Attesa: Dopo aver cancellato il proprio account, l'utente dovrà attendere almeno 3 mesi prima di poter utilizzare nuovamente gli stessi contatti per creare un nuovo account. Questo periodo può essere esteso fino a un massimo di 6 mesi a discrezione di Votiamo, al fine di prevenire abusi e garantire l'integrità dei sondaggi.</li>
        <li>Restrizioni di Registrazione: Durante il periodo di attesa, qualsiasi tentativo di registrazione con gli stessi contatti sarà bloccato e l'utente riceverà una notifica che informa del periodo residuo necessario prima di poter creare un nuovo account.</li>
        <li>Eccezioni: In casi particolari, Votiamo si riserva il diritto di ridurre o estendere il periodo di attesa in base alla natura delle richieste degli utenti o in risposta a comportamenti sospetti. Gli utenti saranno informati delle modifiche tramite email o notifiche all'interno dell'app.</li>
        <li>Recupero Account: Se un utente desidera recuperare il proprio account prima del completamento del periodo di attesa, può contattare il team di supporto di Votiamo. La riattivazione dell'account sarà valutata caso per caso e non garantita.</li>
    </ul>
    <p>Queste misure sono implementate per garantire un ambiente sicuro e prevenire abusi, assicurando che la partecipazione ai sondaggi sia equa e rappresentativa.</p>
</section>

<section>
    <h2>11. Contatti</h2>
    <p>Per qualsiasi domanda o per richiedere assistenza, gli utenti possono contattare il team di supporto di Votiamo tramite il modulo di contatto (Ticket) presente all'interno dell'app o scrivendo a <a href="mailto:support@votiamo.com">support@votiamo.com</a></p>
</section>

<section>
    <h2>Accettazione dei Termini</h2>
    <p>Utilizzando l'app Votiamo, l'utente accetta di rispettare questi Termini e Condizioni. Se l'utente non accetta uno o più punti di questi Termini, è invitato a non utilizzare l'app.</p>
    <p>Grazie per aver scelto Votiamo.</p>
</section>

<footer>
    <p>&copy; 2026 Votiamo. Tutti i diritti riservati.</p>
</footer>
</body>
</html>

`)
};